import { jsx } from "react/jsx-runtime";
import { createContext, useContext, useRef } from "react";
import { createStore } from "zustand";
import use_resize_observer from "use-resize-observer";
import { useTheme } from "../useTheme.js";
import { getFallbackBreakpointsStore, setActiveBreakpoint as external_breakpoint_provider_model_js_setActiveBreakpoint } from "./breakpoint-provider-model.js";
const ElementBreakpointsContext = /*#__PURE__*/ createContext(void 0);
function ElementBreakpointsProvider({ children }) {
    const { theme: { breakpoints } } = useTheme();
    const storeRef = useRef();
    if (!storeRef.current) storeRef.current = initializeBreakpointStore(breakpoints);
    const setActiveBreakpoint = storeRef.current.getState().setActiveBreakpoint;
    const { ref } = use_resize_observer({
        onResize: ({ width })=>{
            if ('number' == typeof width) {
                const activeBreakpoint = getActiveBreakpointFromWidth(breakpoints, width);
                if (activeBreakpoint) setActiveBreakpoint(activeBreakpoint);
            }
        }
    });
    return /*#__PURE__*/ jsx(ElementBreakpointsContext.Provider, {
        value: {
            store: storeRef.current,
            ref
        },
        children: children
    });
}
function getActiveBreakpointFromWidth(breakpoints, width) {
    for(let i = 0; i < breakpoints.keys.length; i++){
        const breakpointKey = breakpoints.keys[i];
        if (i < breakpoints.keys.length - 1) {
            const nextBreakpointKey = breakpoints.keys[i + 1];
            const startWidth = breakpoints.values[breakpointKey];
            const endWidth = breakpoints.values[nextBreakpointKey];
            if (width >= startWidth && width < endWidth) return breakpointKey;
        } else {
            const startWidth = breakpoints.values[breakpointKey];
            if (width >= startWidth) return breakpointKey;
        }
    }
}
function initializeBreakpointStore(breakpoints) {
    if ('test' === process.env.NODE_ENV && 'true' !== process.env.SKIP_ELEMENT_BREAKPOINTS_FALLBACK) return getFallbackBreakpointsStore();
    return createStore()((set)=>({
            isLoading: true,
            setActiveBreakpoint: (breakpoint)=>set(()=>external_breakpoint_provider_model_js_setActiveBreakpoint(breakpoints, breakpoint))
        }));
}
const useElementBreakpointsContext = ()=>{
    const context = useContext(ElementBreakpointsContext);
    if (!context) if ('test' === process.env.NODE_ENV) return {
        store: getFallbackBreakpointsStore(),
        ref: ()=>{}
    };
    else throw new Error('Missing ElementBreakpointsProvider');
    return context;
};
const useElementBreakpointsStore = ()=>{
    const { store } = useElementBreakpointsContext();
    return store;
};
export { ElementBreakpointsProvider, useElementBreakpointsContext, useElementBreakpointsStore };

//# sourceMappingURL=ElementBreakpointsProvider.js.map